/**
 * HubScheduleComponent created by karora on 28/03/17.
 */
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';

import { AppComponent } from '../app.component';
import { HubService } from '../services/hub.service';
import { ScheduleEvent } from '../types/schedule-event';

class dayEvents {
  day: string;
  events: ScheduleEvent[];
}

@Component({
  selector: 'hub-schedule',
  template: `<hub-sub-menu></hub-sub-menu>
<div id="schedule" *ngIf="schedule && schedule.length > 0; else empty">
  <div *ngFor="let day of DaysOfWeek" class="day-events">
    <span class="day">{{day}}</span>
    <span class="schedule">
      <ng-container *ngIf="processedSchedule[day]">
        <span *ngFor="let event of processedSchedule[day].events" class="event_button">{{event.pretty}} <span class="event_delete" (click)="deleteEvent(event)">X</span></span>
      </ng-container>
    </span>
  </div>
  <div id="clear_schedule">
    <button mat-raised-button  id="clear_schedule_button" color="primary" (click)="clearSchedule()" >Clear Schedule</button>
  </div>
</div>
<ng-template #empty>No events in schedule</ng-template>`,
  styles: [
    `.day-events { display: block; color: #1e1e1e; background-color: #d0d0d0; margin: 0.2em 0;
    vertical-align: middle; line-height: 200%; width: 100%; min-width: 32em; }`,
    `span { display: inline-block; border-radius: 0; border: none; padding: 0.3em 0.6em; }`,
    `.day { font-weight: bold; width: 6.5em; color: #d0d0d0; background-color: #1e1e1e;}`,
    `.event_button { width: 10em; text-align: center; border: thin solid #1e1e1e; border-radius: 0.3em; padding: 0 0 0 0.1em; vertical-align: middle; margin-right: 0.5em;}`,
    `.event_delete { width: 1.55em; height: 1.55em; font-size: 128%; font-weight: bold; color: white; background-color: #3f51b5; padding: 0; margin: 0; float: right;}`,
  ],
  providers: [HubService],
})


export class HubScheduleComponent implements OnInit {
  schedule: ScheduleEvent[];
  hubID: number;
  private fromTimestamps: string[];
  errorMessage: string;
  DaysOfWeek: string[] = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  processedSchedule: dayEvents[];

  static handleRefreshError(err: any): void {
    if (err.status !== 401) {
      console.log('HubSchedule Error: ' + err);
    }
  }

  constructor(
    private hubService: HubService,
    private route: ActivatedRoute,
  ) { }

  ngOnInit(): void {
    if (!AppComponent.IsLoggedIn()) { return; }
    this.route.params.pipe(
      switchMap((params: Params) => this.switchedHub(+params['hubid']))
    ).subscribe(
      values => this.newSchedule(values),
      err => HubScheduleComponent.handleRefreshError(err)
    );
  }

  switchedHub(hubID: number): Observable<Object[]> {
    console.log('Switched HUB: ' + hubID);
    this.hubID = hubID;
    this.fromTimestamps = <string[]>{};
    return this.hubService.getSchedule(+this.hubID);
  }

  newSchedule(events: Object[]): void {
    try {
      console.log(`Got some events back: ${JSON.stringify(events)}`);
      this.schedule = events as ScheduleEvent[];
      this.processSchedule();
    } catch (e) {
      console.log(e);
    }
  }

  processSchedule(): void {
    let ps = <dayEvents[]>[];
    let starts: number;
    let startMinute: number;
    let startHour: number;
    for (let event of this.schedule) {
      try {
        startMinute = event.start % 60;
        starts = (event.start - startMinute) / 60;
        startHour = starts % 24;
        event.dow = (starts - startHour) / 24;
        let day = this.DaysOfWeek[event.dow];

        event.pretty = AppComponent.zpad(startHour, 2);
        event.pretty += ':' + AppComponent.zpad(startMinute, 2);
        event.pretty += '+' + (event.stop - event.start);
        if (event.adjust != 0) {
          event.pretty += '[' + (event.adjust > 0 ? '+' : '') + (event.adjust / 10) + ']';
        }

        console.log(`Event: ${event.dow}, ${event.pretty}`);

        if (ps[day]) {
          ps[day].events.push(event);
        } else {
          ps[day] = <dayEvents>{
            day: this.DaysOfWeek[event.dow],
            events: [event],
          };
        }
      } catch (e) {
        console.log('processSchedule: ' + e);
      }
    }
    this.processedSchedule = ps;
  }

  clearSchedule(): void {
    this.hubService.clearSchedule(+this.hubID).subscribe(() => this.newSchedule(null));
  }

  deleteEvent(event: ScheduleEvent): void {
    console.log(`Deleting event UID ${event.uid} ${event.pretty}`);
    this.hubService.deleteEvent(+this.hubID, event.uid)
      .subscribe(
        () => this.hubService.getSchedule(+this.hubID)
          .subscribe(
            values => this.newSchedule(values),
            err => HubScheduleComponent.handleRefreshError(err)
          ),
        err => HubScheduleComponent.handleRefreshError(err)
      );
  }
}

